import { useMutation } from '@tanstack/react-query'

import { generateMoreLikeThisVariants } from '../api'

const useMoreLikeThisVariantsMutation = () => {
  return useMutation({ mutationFn: generateMoreLikeThisVariants })
}

export default useMoreLikeThisVariantsMutation
